import { useCurrentOrganization } from "../../AuthWrapper2/hooks/useCurrentOrganization.js";
import { useOrganization } from "../../Organizations/hooks/useOrganization.js";
// src/modules/Scheduling/hooks/useOrganizationSchedulingSettings.ts
/**
* The organization's self-service switches: whether users may request time
* off and change their availability, and whether each needs approval.
* Remote-first, so a switch an admin just changed doesn't read stale.
* `fire: false` skips the call, for a component rendered once per row that
* only needs the switches on some rows.
*/
function useOrganizationSchedulingSettings(opts = {}) {
	const organization = useCurrentOrganization();
	const { data, loading } = useOrganization(opts.fire === false ? void 0 : { organizationId: organization.id }, { cacheStrategy: "remote-first" });
	return {
		data: data?.organization.schedulingSettings,
		loading
	};
}
export { useOrganizationSchedulingSettings };

//# sourceMappingURL=useOrganizationSchedulingSettings.js.map